import { FunctionComponent } from "react";
import Instancias from "../../../pages/admin-archivos/instancias/Main";
import Delitos from "../../../pages/admin-archivos/delitos/Main";
import Distritos from "../../../pages/admin-archivos/distritos/Main";
import Areas from "../../../pages/admin-archivos/areas/Main";
import TiposFolder from "../../../pages/admin-archivos/tipos-folder/Main";
import Materias from "../../../pages/admin-archivos/materias/Main";
import Regiones from "../../../pages/admin-archivos/regiones/Main";

const rutasComplArchivos: Array<{ path: string; elemento: FunctionComponent }> = [
    { path: "/instancias", elemento: Instancias },
    { path: "/delitos", elemento: Delitos },
    { path: "/distritos", elemento: Distritos },
    { path: "/regiones", elemento: Regiones },
    { path: "/areas", elemento: Areas },
    { path: "/tipos-folder", elemento: TiposFolder },
    { path: "/materias", elemento: Materias },
];

export default rutasComplArchivos;
